import React, { FC } from 'react';
import { Customer } from '../invoices.model';
import { getAddressAsString } from 'containers/jobs/utils';

interface BillToSectionProps {
  customer: Customer;
  isEstimate?: boolean;
}

const BillToSection: FC<BillToSectionProps> = ({ customer, isEstimate = false }) => {
  const { name, lastName, email, phoneNumber, billingAddress, serviceAddress } = customer ?? {};

  return (
    <div className="flex flex-col rounded-md border border-borderGray bg-white p-10 sm:flex-row">
      <div className="w-[45%]">
        <div className="text-sbase font-semibold text-headingBlack">{isEstimate ? 'ESTIMATE FOR' : 'BILLED TO'}</div>
        <div className="mt-5 flex flex-col gap-y-2 text-sbase font-normal text-primaryText">
          {name && <div>{`${name} ${lastName}`}</div>}
          {phoneNumber && <div>{phoneNumber}</div>}
          {email && <div>{email}</div>}
          {billingAddress ? (
            <div className="max-w-[170px] whitespace-pre-line break-words">{getAddressAsString(billingAddress)}</div>
          ) : (
            <></>
          )}
        </div>
      </div>
      {serviceAddress && serviceAddress.length > 0 && (
        <div className="mt-10 w-[55%] sm:mt-0">
          <div className="text-sbase font-semibold text-headingBlack">SERVICE ADDRESS</div>
          <div className="mt-5 max-w-[170px] whitespace-pre-line break-words text-sbase text-primaryText">
            {getAddressAsString(serviceAddress[0])}
          </div>
        </div>
      )}
    </div>
  );
};

export default BillToSection;
